import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import CustomBooleanFilterCell from 'src/components/custom-cells/CustomBooleanFilterCell';

const errorOptions = [
  {
    text: 'Has errors',
    operator: true,
  },
  {
    text: 'Does not have errors',
    operator: false,
  },
];

const ErrorFilterMenuCell = (props: GridColumnMenuProps) => (
  <CustomBooleanFilterCell {...props} option={errorOptions} />
);

export default ErrorFilterMenuCell;
